module.exports = __webpack_public_path__ + "media/images/icons-526f9f0a6925bcaf3b93168f13948e3f.png";